var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_992_3263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1416 0.347656C8.27965 0.347656 0.285156 8.34215 0.285156 18.2041C0.285156 28.0661 8.27965 36.0606 18.1416 36.0606C28.0036 36.0606 35.9981 28.0661 35.9981 18.2041C35.9981 8.34215 28.0036 0.347656 18.1416 0.347656ZM13.7705 25.6053H10.1546V13.9688H13.7705V25.6053ZM11.9402 12.5403C10.7982 12.5403 10.0597 11.7312 10.0597 10.7304C10.0597 9.70928 10.8205 8.92434 11.9867 8.92434C13.153 8.92434 13.8672 9.70928 13.8896 10.7304C13.8896 11.7312 13.153 12.5403 11.9402 12.5403ZM26.9769 25.6053H23.3609V19.1565C23.3609 17.6554 22.8364 16.6361 21.5288 16.6361C20.5299 16.6361 19.9366 17.3262 19.6743 17.9902C19.5776 18.2264 19.5534 18.5613 19.5534 18.8942V25.6034H15.9356V17.6796C15.9356 16.2269 15.8891 15.0123 15.8407 13.9669H18.9824L19.1479 15.5833H19.2205C19.6966 14.8244 20.8629 13.7047 22.8141 13.7047C25.1931 13.7047 26.9769 15.2987 26.9769 18.7249V25.6053Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_992_3263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.7129,
    height: 35.7129,
    fill: "white",
    transform: "translate(0.285156 0.347656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.c1ba26fa07d624caf3a38938edfb52c2.svg";
export { ForwardRef as ReactComponent };